import { Routes } from '@angular/router';
import { ShellComponent } from 'app/shared/layout/shell/shell.component';
import { AuthenticationGuard } from './authentication/authentication.guard';

/**
 * Provides helper methods to create routes.
 */
export class Route {

  /**
   * Creates routes using the shell component and authentication.
   * @param routes The routes to add.
   * @return {Routes} The new routes using shell as the base.
   */
  static withShell(routes: Routes, requireAuthentication: boolean = true): Routes {
    return [{
      path: '',
      component: ShellComponent,
      children: routes,
      canActivate: requireAuthentication ? [AuthenticationGuard] : null
    }];
  }

}



// WEBPACK FOOTER //
// C:/ProactiView/ProactiView-Client/src/app/core/route.service.ts